import { usePathname } from 'next/navigation'

import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'

import useDeviceInfo, { DEVICE_TYPES } from '../../../useDeviceInfo'

export default function useMobileCartPageExperiment() {
  const experimentName = STATSIG_EXPERIMENTS.MOBILE_CART_PAGE_EXPERIMENT
  const { experimentBucket, init } = useStatsigExperiment(experimentName)
  const experimentConfig = STATSIG_EXPERIMENTS_CONFIG[experimentName]
  const deviceInfo = useDeviceInfo()
  const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE
  const pathname = usePathname() || ''
  const isCartPage = pathname.endsWith('/cart')

  const isControlBucketOnMobile = experimentConfig?.buckets?.control === experimentBucket && isMobile
  const isShowABucketOnMobile = experimentConfig?.buckets?.showA === experimentBucket && isMobile && isCartPage
  const isShowBBucketOnMobile = experimentConfig?.buckets?.showB === experimentBucket && isMobile && isCartPage

  const hideCartPageFooter = isShowBBucketOnMobile || isShowABucketOnMobile
  const hideCartPageHeader = isShowABucketOnMobile
  const disableCartPopupOnMobileCartPage = isShowABucketOnMobile || isShowBBucketOnMobile
  const isPreviousPageSafeEnabled = experimentConfig?.buckets?.showA === experimentBucket && isMobile

  return {
    buckets: {
      isControlBucketOnMobile,
      isShowABucketOnMobile,
      isShowBBucketOnMobile,
    },
    hideCartPageFooter,
    hideCartPageHeader,
    isCartPage,
    disableCartPopupOnMobileCartPage,
    isExperimentInitialized: init,
    isPreviousPageSafeEnabled,
  }
}
